import React from "react";
import { header } from "../../assets";
import { useNavigate } from "react-router-dom";
import { BsBookmarkPlus, BsFillCalendar2CheckFill } from "react-icons/bs";
import { FaUserDoctor } from "react-icons/fa6";
import { BiCut, BiSolidHappyHeartEyes } from "react-icons/bi";
import { motion } from "framer-motion";
import { LazyLoadImage } from "react-lazy-load-image-component";


const HowWorks = () => {
  const navigate = useNavigate();
  return (
    <motion.div
      className="howWorks"
      whileInView={{ y: [50, 0], opacity: [0, 1] }}
      transition={{ duration: 0.5 }}
    >
      <div className="left">
        <LazyLoadImage effect="blur" src={header} alt="" className="banner"/>
      </div>
      <div className="right">
        <small className="t1">How it works</small>
        <h1>Making What’s Good Even Better</h1>
        <p>
        At Laser Treat, our beauty treatments begin with a personalized consultation and assessment to understand your needs and goals. We provide expert treatments using cutting-edge technology and quality products. Aftercare and follow-up appointments ensure optimal results, boosting your confidence and self-esteem.
        </p>

        <div className="steps">
          <div className="step">
            <div className="ico-bg">
              <BsFillCalendar2CheckFill className="ico" />
            </div>
            <p>Appointment</p>
          </div>
          <div className="line"></div>

          <div className="step">
            <div className="ico-bg">
              <FaUserDoctor className="ico" />
            </div>
            <p>Consultation</p>
          </div>
          <div className="line"></div>

          <div className="step">
            <div className="ico-bg">
              <BiCut className="ico" />
            </div>
            <p>Treatment</p>
          </div>
          <div className="line"></div>

          <div className="step">
            <div className="ico-bg">
              <BiSolidHappyHeartEyes className="ico" />
            </div>
            <p>New Look</p>
          </div>
        </div>

        <button className="booking" onClick={() => navigate("/appointment")}>
          <div className="ico-bg">
          </div>
          <small>Book Appointment</small>
        </button>
      </div>
    </motion.div>
  );
};

export default HowWorks;
